import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaCnhEstrangeiroRequest } from './types';

// ACTIONS
import {
	consultaCnhEstrangeiroSuccess,
	consultaCnhEstrangeiroFailure,
} from './actions';

function* consultaRenovacaoCnh(request: ReducerAction) {
	const { payload }: { payload: ConsultaCnhEstrangeiroRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`eportal/${CHANNEL}/pesquisa/cnh-estrangeiro`,
		payload,
	);

	if (response.status === 200 || response.status === 204) {
		yield put(consultaCnhEstrangeiroSuccess({ response, request: payload }));
	} else {
		yield put(
			consultaCnhEstrangeiroFailure({
				response: response.data,
				request: payload,
			}),
		);
	}
}

export default all([
	takeLatest(Types.CONSULTA_CNH_ESTRANGEIRO_REQUEST, consultaRenovacaoCnh),
]);
